export const email = "hello.leszek.mikrut@gmail.com"